module.exports = __webpack_public_path__ + "static/python-3be588ca1513a4c18956a56c79f5c47e.png";